module.exports = __webpack_public_path__ + "prototype.kUZZh9u1.svg";